import { createAtlAttributionHeader } from '../../../../../common/fetch/atl-attribution-header';
import { fetchAggResponse } from '../../../../../common/fetch/fetch-agg-response';
import { logger } from '../../../../../common/utils/logger';
import {
	CONFLUENCE_PAGE_OUTGOING_LINKS_OPERATION_NAME,
	KnowledgeDiscoveryConfluencePageOutgoingLinksQuery,
} from '../gql/confluence-page-outgoing-links-query';
import type {
	ConfluencePageLinksVariables,
	ConfluencePageOutgoingLinksResponse,
} from '../gql/types';
import { processLinkRowItem } from './utils';

export const getConfluencePageOutgoingLinks = async ({
	id,
	workspaceId,
	cloudId,
	product,
}: {
	id: string;
	workspaceId: string;
	cloudId: string;
	product: string;
}): Promise<string[] | null | undefined> => {
	try {
		const urls: string[] = [];
		const { data, errors } = await fetchAggResponse<
			ConfluencePageLinksVariables,
			ConfluencePageOutgoingLinksResponse
		>({
			graphQuery: KnowledgeDiscoveryConfluencePageOutgoingLinksQuery,
			variables: { id },
			operationName: CONFLUENCE_PAGE_OUTGOING_LINKS_OPERATION_NAME,
			headers: {
				...createAtlAttributionHeader({
					atlWorkspaceId: workspaceId,
					tenantId: cloudId,
					product,
				}),
				'X-Query-Context': workspaceId,
			},
		});
		if (errors) {
			logger.error({
				feature: 'knowledge-cards',
				element: 'container',
				operation: 'fetch-outgoing-links',
				category: 'graphql',
				error: errors[0],
				functionName: 'getConfluenceOutgoingLinks',
			});
			return null;
		}

		data?.linksOutgoingFromConfluencePage.queryResult.rows.forEach((row) => {
			row.rowItems.forEach((item) => {
				const link = processLinkRowItem(item);
				if (link) {
					urls.push(link);
				}
			});
		});

		return urls;
	} catch (error) {
		logger.error({
			feature: 'knowledge-cards',
			element: 'container',
			operation: 'fetch-outgoing-links',
			category: 'unknown',
			error,
			functionName: 'getConfluenceOutgoingLinks',
		});
		return null;
	}
};
